// extracted by mini-css-extract-plugin
module.exports = {"incut":"incut-link_incut__cRF8t","incut__image":"incut-link_incut__image__UXYgO","incut__text":"incut-link_incut__text__sEDcc"};